export const STATUS_FILTERS = [
  { text: 'Yes', value: 'true' },
  { text: 'No', value: 'false' },
]

export const GUEST_EMAIL_REG_EXP = /guest_\d*@(karmanow|shoptagr)\.com/
